/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}button`;
const observedAttributes = {
    VARIANT: 'variant',
    PILL: 'pill',
    THEME: 'theme',
    FULL_WIDTH: 'full-width'
};
const attributes = {
    ...observedAttributes
};
export const BUTTON_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes
};
